import { useContext } from 'react';
import { type Looker40SDK } from '@looker/sdk';

import { LookerSdkContext } from '@/providers/looker-sdk';

export function useLookerSdk(): Looker40SDK {
  return useContext(LookerSdkContext);
}
